import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as reportReducer from "containers/Report/ReportReducer";

import SubView from "components/View/SubView";

import ReportTile from "components/Tiles/Report/Report";

class ReportViewContainer extends React.PureComponent {
  render() {
    const { onClick, isTile, history, deleteReport, data, getChartsOrder } = this.props;

    return (
      <SubView
        {...this.props}
        data={data}
        label="Reports"
        headers={[]}
        firstTile={<div />}
        firstRow={<div />}
        length={data.length}
        isInfinite={true}
        renderTile={(columnIndex, style) =>
          data && data.length > columnIndex ? (
            <ReportTile
              id={data[columnIndex].id}
              report={data[columnIndex]}
              key={columnIndex}
              style={style}
              onClick={() => history.push("report/" + data[columnIndex].id)}
              handleDelete={() => deleteReport(data[columnIndex].id)}
            />
          ) : undefined
        }
        childrenLength={data.length}
        isTile={isTile}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  deleteReport: (id) => dispatch(reportReducer.deleteReport(id))
});

const mapStateToProps = (state, ownProps) => {
  const selectedFolder = foldersReducer.getSelectedFolder(state);

  return {
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),

    data: viewReducer.getReports(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ReportViewContainer);
